import { object, string, array, mixed } from 'yup';

export default object().shape({
  keyRelease: string().required('Key Release is required'),
  keyReleaseEmail: array()
    .of(
      string()
        .email(' ')
        .required(' ')
    )
    .required('Emails are is required')
    .min(1, 'Please add at least 1 email'),
  scheduleEmail: array()
    .of(string().email(' '))
    .optional(),
  status: string().required('Status is required'),
  regionID: string().required('Please select Region'),
  activeAt: mixed().when('status', {
    is: 'inactive',
    then: object().required('Active date is required')
  }),
  firstDayOfService: object().required('First Day of Service is required')
});
